import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c304e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value", "checked", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseHeader = _resolveComponent("CloseHeader")!
  const _component_SelectFilter = _resolveComponent("SelectFilter")!
  const _component_RelationHeader = _resolveComponent("RelationHeader")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_OrderTableHeader = _resolveComponent("OrderTableHeader")!
  const _component_Row = _resolveComponent("Row")!
  const _component_Cell = _resolveComponent("Cell")!
  const _component_PersonPhoto = _resolveComponent("PersonPhoto")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ListPicker = _resolveComponent("ListPicker")!

  return (_openBlock(), _createBlock(_component_ListPicker, { onCloseModal: _ctx.close }, {
    header: _withCtx(() => [
      _createVNode(_component_CloseHeader, {
        onCloseModal: _ctx.close,
        title: "Recomendar treinamento"
      }, null, 8, ["onCloseModal"]),
      _createVNode(_component_RelationHeader, {
        onRelateEntities: _ctx.save,
        buttonTitle: "Recomendar",
        onSearching: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search(_ctx.$router, $event, 'name')))
      }, {
        filters: _withCtx(() => [
          _createVNode(_component_SelectFilter)
        ]),
        _: 1
      }, 8, ["onRelateEntities"])
    ]),
    table: _withCtx(() => [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_DataTable, { height: _ctx.tableHeight }, {
            thead: _withCtx(() => [
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_TableHeader, {
                    space: "0.5/15",
                    text: "Seleção",
                    alignment: "center"
                  }),
                  _createVNode(_component_TableHeader, {
                    space: "1/15",
                    alignment: "center",
                    text: "Foto"
                  }),
                  _createVNode(_component_OrderTableHeader, {
                    space: "4/15",
                    alignment: "left",
                    text: "Nome",
                    orderBy: "name"
                  }),
                  (_ctx.showPermissionColumn)
                    ? (_openBlock(), _createBlock(_component_TableHeader, {
                        key: 0,
                        space: "4/15",
                        alignment: "center",
                        text: "Permissão",
                        orderBy: "userTypeLabel"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            tbody: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                return (_openBlock(), _createBlock(_component_Row, {
                  key: index,
                  onClick: ($event: any) => (_ctx.checkRow(user)),
                  "is-clickable": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Cell, { label: "Seleção" }, {
                      default: _withCtx(() => [
                        _createElementVNode("input", {
                          class: "input-checkbox",
                          type: "checkbox",
                          id: `user${user.id}`,
                          value: user.id,
                          checked: _ctx.selectedIDs.has(user.id),
                          onChange: ($event: any) => (_ctx.toggleUserSelection(user)),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }, null, 40, _hoisted_1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Cell, {
                      label: "Foto",
                      alignment: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PersonPhoto, {
                          image: user.image,
                          name: user.name
                        }, null, 8, ["image", "name"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Cell, {
                      text: user.name,
                      label: "Nome",
                      alignment: "left"
                    }, null, 8, ["text"]),
                    (_ctx.showPermissionColumn)
                      ? (_openBlock(), _createBlock(_component_Cell, {
                          key: 0,
                          text: user.userTypeLabel,
                          label: "Permissão",
                          alignment: "center"
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            pagination: _withCtx(() => [
              _createVNode(_component_Pagination, {
                "qt-pages": _ctx.numberOfPages,
                currentPage: Number(_ctx.$route.query.page) || 1,
                onChangePage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'page', $event))),
                class: "pagination",
                hasBackground: false,
                roundedStyle: "small",
                itemSize: "small",
                primaryColor: "#31639f",
                justifyContent: "flex-start"
              }, null, 8, ["qt-pages", "currentPage"])
            ]),
            _: 1
          }, 8, ["height"])
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["onCloseModal"]))
}